(function () {
  'use strict';

  /* Correspondance couleur → code hex (palette omoon) */
  var COULEUR_HEX = {
    'Rouge':  '#C0392B',
    'Bleu':   '#2471A3',
    'Vert':   '#1E8449',
    'Jaune':  '#D4AC0D',
    'Noir':   '#1C2833',
    'Blanc':  '#F0F0F0'
  };

  var destinations = (window.OMOON_DESTINATIONS || [])
    .slice()
    .sort(function (a, b) { return a.ordre - b.ordre; });

  var grille    = document.getElementById('od-grille');
  var vide      = document.getElementById('od-vide');
  var searchEl  = document.getElementById('od-search-input');
  var filtres   = document.querySelectorAll('.od-filtre');

  var continentActif = 'Toutes';
  var recherche      = '';

  function render() {
    var resultats = destinations.filter(function (d) {
      var matchContinent = continentActif === 'Toutes' || d.continent === continentActif;
      var matchRecherche = d.nom.toLowerCase().indexOf(recherche) !== -1;
      return matchContinent && matchRecherche;
    });

    if (resultats.length === 0) {
      grille.innerHTML = '';
      vide.hidden = false;
      return;
    }

    vide.hidden = true;
    grille.innerHTML = resultats.map(function (d) {
      var hex = COULEUR_HEX[d.couleur] || '#ccc';
      return (
        '<div class="od-carte" data-handle="' + d.handle + '">' +
          '<div class="od-carte__drapeau">' + d.drapeau + '</div>' +
          '<div class="od-carte__nom">' + d.nom + '</div>' +
          '<div class="od-carte__couleur-wrap">' +
            '<span class="od-carte__dot" style="background:' + hex + '"></span>' +
            '<span class="od-carte__couleur">' + d.couleur + '</span>' +
          '</div>' +
          '<div class="od-carte__pierre">' + d.pierre + '</div>' +
        '</div>'
      );
    }).join('');
  }

  /* Recherche */
  searchEl.addEventListener('input', function () {
    recherche = this.value.toLowerCase().trim();
    render();
  });

  /* Filtres continent */
  filtres.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filtres.forEach(function (b) { b.classList.remove('od-filtre--actif'); });
      this.classList.add('od-filtre--actif');
      continentActif = this.dataset.continent;
      render();
    });
  });

  /* Rendu initial */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  /*
   * HOOK FUTUR — présélection dans le funnel
   * Pour activer : ajouter data-handle sur chaque carte et écouter le clic.
   * Exemple : window.location.href = '/pages/creer-mon-bracelet?destination=' + d.handle;
   * Aucune modification d'architecture nécessaire.
   */
})();
